import { BaseEntity } from 'yt-ng-framework';
export class MestoView extends BaseEntity {
    constructor(){
        super();
    }

    Naziv: string;
    Opstina: string;
    PostBroj: string;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Opstina = input.Opstina;
        this.PostBroj = input.PostBroj;

        return this;
    }

    Serialize(input: MestoView){
        return input;
    }
}